import {
    RECEIPT_PROVIDER_LIST_REQUEST_SUCCESS,
    RECEIPT_PROVIDER_LIST_REQUEST_FAIL 
} from "../action.types";
import initialValue from "../initial.state";

export default function (state = initialValue.providerReceipts, action) {
    switch (action.type) {
        case RECEIPT_PROVIDER_LIST_REQUEST_SUCCESS:
            return action.payload.values;
          case RECEIPT_PROVIDER_LIST_REQUEST_FAIL:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/file/providerReceipts.reducer.js